import { render, staticRenderFns } from "./UserFeatureManagement.vue?vue&type=template&id=89b6cf02&scoped=true"
import script from "./UserFeatureManagement.vue?vue&type=script&lang=js"
export * from "./UserFeatureManagement.vue?vue&type=script&lang=js"
import style0 from "./UserFeatureManagement.vue?vue&type=style&index=0&id=89b6cf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b6cf02",
  null
  
)

export default component.exports